import { ContactPersonModel } from '@models/contact-person.model';
import { MediaImageModel } from '@modules/media/models/media-image.model';

import { SectionType } from '../enums/section-type.enum';

export interface ContactSectionInterface {
  headline?: string;
  anchor?: string;
  contacts: ContactInterface[];
}
export interface ContactInterface {
  fullname: string;
  position: string;
  email: string;
  phone: string;
  media?: MediaImageModel;
  initials?: string;
}

export class ContactSectionModel {
  public type = SectionType.CONTACT;
  public headline?: string;
  public anchor?: string;
  public contacts: ContactPersonModel[];

  constructor(data: ContactSectionInterface) {
    this.headline = data.headline;
    this.anchor = data.anchor;
    this.contacts = data.contacts.map((item) => {
      return new ContactPersonModel(item);
    });
  }
}
